import { render } from "./Auth.vue?vue&type=template&id=654e2eb6&scoped=true&bindings={\"onRedirect\":\"setup\",\"containerClassName\":\"setup\",\"handleOnRegister\":\"setup\",\"handleOnLogin\":\"setup\"}"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=654e2eb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-654e2eb6"

export default script